export default __webpack_public_path__ + "static/media/password-show.53e54c03.svg";